var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-tab"},[_c('DeviceStatus'),_c('DevicePlotList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }